import style from "./InfoTag.module.css";

const InfoTag = ({ message }) => {
  return (
    <div className={style["tooltip-container"]}>
      <svg className={style["info-icon"]} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v2h-2zm0 4h2v6h-2z" />
      </svg>
      <span className={style["tooltip-text"]}>{message}</span>
    </div>
  );
};

export default InfoTag;
